import { render, staticRenderFns } from "./CriteriaSurveyAccessLinks.vue?vue&type=template&id=7eb8f4c0&scoped=true"
import script from "./CriteriaSurveyAccessLinks.vue?vue&type=script&lang=ts"
export * from "./CriteriaSurveyAccessLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb8f4c0",
  null
  
)

export default component.exports